import React from "react";
import { Link } from "react-router-dom";

const DescriptionStep = ({ formData, updateFields }) => {
  const handleChange = (event) => {
    const { name, type, checked, value } = event.target;
    updateFields({ [name]: type === "checkbox" ? checked : value });
  };

  return (
    <div>
      <h3 className="font-playfair text-2xl font-bold text-gray-900 mb-2">
        Derniers détails
      </h3>
      <p className="text-gray-500 text-sm mb-8">Décrivez votre gâteau idéal</p>
      <div className="space-y-5">
        <div>
          <label htmlFor="cake-description" className="block text-sm font-medium text-gray-700 mb-1.5">
            Description du gâteau souhaité
          </label>
          <textarea
            id="cake-description"
            name="description"
            value={formData.description}
            onChange={handleChange}
            rows={5}
            className="w-full px-4 py-3.5 rounded-xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-[#E5007D]/30 focus:border-[#E5007D] transition-all bg-white text-sm resize-none"
            placeholder="Thème, couleurs, décoration spécifique, allergies alimentaires..."
          />
        </div>
        <div className="bg-white rounded-xl p-5 border border-gray-200">
          <div className="flex items-start gap-3">
            <input
              type="checkbox"
              id="acceptConditions"
              name="acceptConditions"
              checked={formData.acceptConditions}
              onChange={handleChange}
              required
              aria-describedby="acceptConditions-text"
              className="mt-1 w-4 h-4 shrink-0 rounded border-gray-300 text-[#E5007D] focus:ring-[#E5007D]"
            />
            <p id="acceptConditions-text" className="text-sm text-gray-600 leading-relaxed">
              <label htmlFor="acceptConditions" className="cursor-pointer">J'accepte les </label>
              <Link to="/conditions-commande" target="_blank" rel="noreferrer" className="text-[#E5007D] underline hover:no-underline">
                conditions générales de vente
              </Link>{" "}
              et les{" "}
              <Link to="/mentions-legales" target="_blank" rel="noreferrer" className="text-[#E5007D] underline hover:no-underline">
                mentions légales
              </Link>
              . <span className="text-[#E5007D]" aria-hidden="true">*</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DescriptionStep;
